import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { api } from '../api';
import { setToken } from '../api/http';

const Ctx = createContext(null);
export const useAuth = () => useContext(Ctx);

/**
 * Авторизация целиком существующая: токен Keycloak в localStorage, refresh
 * тем же эндпоинтом, что и в основном приложении. Дэшборд только проверяет,
 * что у вошедшего есть глобальная роль ADMIN.
 */
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Бэкенд возвращает с входа на наш адрес с ?access_token= — забираем и прячем.
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get('access_token');
    if (fromUrl) {
      setToken(fromUrl);
      params.delete('access_token');
      const rest = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (rest ? `?${rest}` : ''));
    }

    api.auth
      .me()
      .then(setUser)
      .catch(() => setUser(null))
      .finally(() => setChecking(false));
  }, []);

  const value = useMemo(
    () => ({
      user,
      checking,
      isAdmin: !!user?.isAdmin,
      // Уровней доступа у дэшборда нет: роль ADMIN даёт всё, что даёт бэкенд.
      canEdit: !!user?.isAdmin,
      signOut: async () => {
        await api.auth.logout().catch(() => {});
        setUser(null);
        window.location.reload();
      },
    }),
    [user, checking]
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}
